<template>
  <a-modal title="编辑体检套餐" :visible="visible" :width="900"
           :confirmLoading="confirmLoading" :destroyOnClose="true" :maskClosable='false'
           @ok="handleSubmit"
           @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="热门套餐" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-select placeholder="请选择" v-decorator="['hotCombo', {rules: [{required: true, message: '请选择是否是热门套餐'}]}]">
            <a-select-option key='1' value="1">是</a-select-option>
            <a-select-option key='2' value="2">否</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="套餐名称" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-input v-decorator="['comboName']" readOnly />
        </a-form-item>

        <a-form-item label="套餐价格" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <!--<a-input-number style='width: 100%' placeholder="请输入套餐价格" v-decorator="['comboPrice', {rules: [{required: true, message: '请输入套餐价格'}]}]" :min="0" :step="0.05"/>-->

          <a-input v-decorator="['comboPrice']" readOnly />
        </a-form-item>

        <a-form-item label="套餐介绍" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-input placeholder="请输入套餐介绍" v-decorator="['comboIntroduce']" />
        </a-form-item>

        <a-form-item label="服务详情" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-input placeholder="请输入套餐服务详情" v-decorator="['details']" />
        </a-form-item>

        <a-form-item label="性别限定" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-select placeholder="请选择性别限定" v-decorator="['gender', {rules: [{required: true, message: '请选择性别限定'}]}]" @change="handleChange">
            <a-select-option key='1' value="1">适用男性</a-select-option>
            <a-select-option key='2' value="2">适应女性</a-select-option>
            <a-select-option key='3' value="3">不限</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="套餐项" :labelCol="labelCol" :wrapperCol="wrapperCol" has-feedback>
          <a-select placeholder="请选择套餐项" v-decorator="['baMedicalProjectIds', {rules: [{required: true, message: '请选择套餐项'}]}]"
                    mode="multiple" show-search :filter-option="handleDeptFilterOption" :options="medProjectList"
                    @change="handleOnChange"
          />
        </a-form-item>

        <!--隐藏域-->
        <a-form-item v-show="false">
          <a-input v-decorator="['id']" />
          <a-input v-decorator="['comboNum']" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import {qryExamProjectList, editExamCombo} from '@/api/modular/interhospital/subIndividual/subIndividual';

  /**
   * @Description: 体检套餐修改
   */
  export default {
    data() {
      return {
        form: this.$form.createForm(this),

        labelCol: {xs: {span: 24}, sm: {span: 5}},
        wrapperCol: {xs: {span: 24}, sm: {span: 15}},

        visible: false,
        confirmLoading: false,
        medProjectList: [], // 体检单项集合
        examList: [], // 体检单项集合，用来计算套餐价格
      }
    },

    methods: {
      // 初始化方法
      edit(record) {
        this.medProjectList = [];
        this.examList = [];

        this.visible = true;
        this.handleGetExamProjectList(record.gender);

        setTimeout(() => {
          this.form.setFieldsValue({
            id: record.id,
            comboNum: record.comboNum,

            hotCombo: record.hotCombo,
            comboName: record.comboName,
            comboPrice: record.comboPrice,
            comboIntroduce: record.comboIntroduce,
            details: record.details,
            gender: record.gender,
            baMedicalProjectIds: record.baMedicalProjectIds.split(',')
          });
        }, 100);
      },

      // 性别限定change事件
      handleChange(value) {
        this.form.resetFields(['baMedicalProjectIds']);
        this.handleGetExamProjectList(value);
      },

      // 获取体检单项信息
      handleGetExamProjectList(value) {
        // 适用男性
        if (value == '1') {
          value = '1,3';
        } else if (value == '2') { // 适用女性
          value = '2,3';
        } else if (value == '3') { // 性别不限
          value = '1,2,3';
        }

        qryExamProjectList(value).then(res => {
          if (res.code == 200) {
            this.examList = res.data;
            res.data.map(item => this.medProjectList.push({value: `${item.id}-${item.projectNum}`, label: `${item.projectPrice}元 -- ${item.projectName}`}));
          } else {
            this.$message.error(res.message);
          }
        });
      },

      // 过滤筛选体检单项
      handleDeptFilterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      // 套餐项 change事件
      handleOnChange(value) {
        let comboPrice = 0;

        for (let i = 0; i < value.length; i++) {
          const id = value[i].split('-')[0];
          const filterRes = this.examList.filter(exam => exam.id == id)[0];
          comboPrice += (!!!filterRes ? 0 : filterRes.projectPrice * 1);
        }
        this.form.setFieldsValue({comboPrice});
      },


      // 修改提交
      handleSubmit() {
        const {form: {validateFields}} = this;
        this.confirmLoading = true;

        validateFields((errors, values) => {
          if (!errors) {
            const tmpStr = values.baMedicalProjectIds.join(",");

            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }

            values.baMedicalProjectIds = tmpStr;

            editExamCombo(values).then((res) => {
              if (res.success) {
                this.$message.success('编辑成功');
                this.confirmLoading = false;
                this.$emit('ok', values);
                this.handleCancel();

              } else {
                this.$message.error('编辑失败')
              }
            }).finally(() => {
              this.confirmLoading = false;
            })
          } else {
            this.confirmLoading = false;
          }
        })
      },

      // 关闭modal框
      handleCancel() {
        this.form.resetFields();
        this.visible = false;
      },
    }
  }
</script>
